import React from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import MainContentContainer from "../../MainContentContainer/MainContentContainer";
import QuickTapsFeaturedTable from "./QuickTapsFeaturedTable";

export default function QuickTapsFeaturedPage() {
  return (
    <MainContentContainer>
      <AppBar position="sticky">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Featured Quick Taps
          </Typography>
          <Button
            color="inherit"
            component={Link}
            to="/quick-taps"
            startIcon={<ArrowBack />}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            Back
          </Button>
        </Toolbar>
      </AppBar>
      <Box sx={{ py: 2 }}>
        <QuickTapsFeaturedTable />
      </Box>
    </MainContentContainer>
  );
}
